// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.insurance.updatepersoninsurance.UpdatePatientGeneralBenefitsRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePatientGeneralBenefitsRequest extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	contactLensFittingBenefitResetDate!: Date | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	contactLensFittingCoPay!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	deductible!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	generalCoPay!: number | null;

	@GandalfProperty({ designType: Boolean })
	hasContactLensFittingBenefit!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	hasRoutineExamBenefit!: boolean | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	medicalExamCoPay!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	routineExamBenefitResetDate!: Date | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	routineExamCoPay!: number | null;

}
